import React from 'react';

import { Badge } from '@mantine/core';

import type { ClonotypeRow } from '../../types/antibodyTable';

const s = {
  muted: 'text-xs text-muted-foreground',
  wrapper: 'flex items-center gap-1',
  text: 'text-xs',
} as const;

interface IsotypeBadgeCellProps {
  row: ClonotypeRow;
}

/** Renders the Ig isotype value with an optional "+N variants" badge. */
export function IsotypeBadgeCell({ row }: IsotypeBadgeCellProps) {
  if (!row.igIsotype) {
    return <span className={s.muted}>-</span>;
  }
  return (
    <div className={s.wrapper}>
      <span className={s.text}>{row.igIsotype}</span>
      {row.igIsotypeVariants > 0 && (
        <Badge size="xs" variant="filled" color="teal" radius="xl">
          +{row.igIsotypeVariants}
        </Badge>
      )}
    </div>
  );
}
